import React from 'react';
import { useTranslation } from 'react-i18next';
import { ActionsProps } from '@lib/components/ReactHookForm/FormContainer';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ActionsRow from '@lib/components/ActionsRow/ActionsRow';
import { SubmitAction } from '@lib/enums/form';

type Props = {
  submitNewAreaRef: React.RefObject<SubmitAction | undefined>;
};

function AreaCreateFormActions(props: ActionsProps & Props) {
  const { onSubmitForm, onCancel, loading, submitNewAreaRef } = props;
  const { t } = useTranslation();
  return (
    <ActionsRow
      actions={[
        <Button
          buttonText={t('cancel')}
          buttonType={ButtonTypes.secondaryOutlined}
          disabled={loading}
          fullWidth
          leftIcon="close"
          onClick={onCancel}
        />,
        <div />,
        <Button
          buttonText={t('save-and-create-next')}
          buttonType={ButtonTypes.primaryOutlined}
          fullWidth
          onClick={() => {
            if (submitNewAreaRef) {
              submitNewAreaRef.current = SubmitAction.CreateAndNew;
            }
            onSubmitForm();
          }}
          disabled={loading}
        />,
        <Button
          buttonText={t('create')}
          buttonType={ButtonTypes.primaryFilled}
          fullWidth
          leftIcon="check"
          onClick={() => {
            if (submitNewAreaRef) {
              submitNewAreaRef.current = SubmitAction.CreateAndClose;
            }
            onSubmitForm();
          }}
          disabled={loading}
        />,
      ]}
    />
  );
}

export default AreaCreateFormActions;
